import React, { Component } from 'react';
import s from './Techs.css';

export default class Techs extends Component {
  render(){
    return pug`
      div(className=s.techs)
        h3(className=s.category) プログラミング

        div(className=s.content)
          h4(className=s.category_child) 言語（得意順）
          p JavaScript(Node.js) / HTML(pug) / CSS(Sass) / C# / PHP / Java / C++ / C
          h4(className=s.category_child) フレームワーク/ライブラリ
          p WordPress / Express / React / Riot.js / jQuery
          h4(className=s.category_child) その他開発技術
          p Vim / Git / GitHub / Slack / ChatWork / Mac / Windows
          h4(className=s.category_child) Paiza ランク
          p Aランク


        h3(className=s.category) 画像処理等
        div(className=s.content)
          p Illustrator / XD / Photoshop / Premiere


        h3(className=s.category) 忍術
        div(className=s.content)
          p 火遁豪火球の術/菜箸手裏剣の術/階段4倍速上り下りの術/水遁の術/十字手裏剣術
          
    `;
  }

}



// WEBPACK FOOTER //
// ./src/Techs.js